<div class="panel-group">
  <div class="panel panel-default">
    <div class="panel-heading">
      <div class="row">
        <h2 class="panel-title col-xs-10">
          <a data-toggle="collapse" href="#collapse1">Ricerca</a>
        </h2>
        <div class="col-xs-2">
          <a data-toggle="collapse" href="#collapse1" aria-expanded="false">
            <span (click)="onLoadData()" class="glyphicon glyphicon-triangle-bottom"></span>
            <span class="glyphicon glyphicon-triangle-top"></span>
          </a>
        </div>
      </div>
    </div>
    <div id="collapse1" class="panel-collapse collapse">
      <div class="panel-body"><app-dynamic-form [questions]="formFields" [config]="formConfiguration"
          (onFormSubmit)="sendSearch($event)"></app-dynamic-form></div>
    </div>
  </div>
</div>

<div class="titleblock">
  <h3 class="title1level">
    Gestione Dipartimenti
  </h3>
  <p>
    <a (click)="addDepartment()" href="javascript:void(0)">
      Aggiungi Dipartimento
      <span class="glyphicon glyphicon-plus-sign"></span>
    </a>
  </p>
</div>
<div class="titleblock">
  <h3 class="title1level" style="padding: 25px 0px 0px 0px"></h3>
  <p style="margin-top: -20px">
    <a (click)="refresh()" href="javascript:void(0)">
      Aggiorna
      <span style="margin-left: 10px;" class="glyphicon glyphicon-refresh"></span>
    </a>
  </p>
</div>

<div *ngIf="dipartments && dipartments.totalItems > 0" class="container_dati_generali">
  <app-dipartimenti-list [pagable] = "pagable"  *ngIf="formFields" (delete)="onDelete($event)" (edit)="onEdit($event)"
    [dipartments]="dipartments" [hasAutoRefresh]="true" (refreshEvent)="refresh($event)"
    [resetCurrentPage]="resetCurrentPage"></app-dipartimenti-list>
</div>

<div *ngIf="!dipartments || dipartments.totalItems === 0" class="container_dati_generali">
  <h5>Non ci sono dipartimenti</h5>
</div>
